// extracted by mini-css-extract-plugin
export default {"header":"Header_header__fGnSt","close-button":"Header_close-button__v0B+d"};